module.exports = __webpack_public_path__ + "static/media/store.0e732bff.svg";